export default __webpack_public_path__ + "static/media/deucesTableWnd.c7539c5e.webp";